import React from 'react';
import { Image } from 'react-bootstrap';

interface HowItWorksContentProps {
	heading: React.ReactNode;
	descriptions: React.ReactNode[];
	imageSrc: string;
	imageAlt: string;
}
const HowItWorksContent: React.FC<HowItWorksContentProps> = ({
	heading,
	descriptions,
	imageSrc,
	imageAlt,
}) => (
	<div className="how-it-works-content">
		<div className="main-heading">
			<h2 className="fw-bold mb-3 mb-md-4">{heading}</h2>
		</div>
		<div>
			{descriptions.map((desc, idx) => (
				<p key={idx}>{desc}</p>
			))}
		</div>
		<Image
			src={imageSrc}
			className="how-it-works-img w-100 mt-0 mt-xxl-3 object-fit-cover"
			alt={imageAlt}
			loading="lazy"
		/>
	</div>
);

export default HowItWorksContent;
